/**
 * @module app.bdc.list.formTillInfoCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function FormTillInfoCtrl($scope, $uibModalInstance, till) {
        var self = {};
        self.till = till;

        self.close = function() {
            $uibModalInstance.dismiss('cancel');
        };
        return self;
    }

    FormTillInfoCtrl.$inject = ['$scope', '$uibModalInstance', 'till'];

    angular
        .module('app.bdc.list.formTillInfoCtrl', ['ui.bootstrap.modal'])
        .controller('FormTillInfoCtrl', FormTillInfoCtrl);
});
